import { isNumber } from 'portaltransparencia-common/libs/NumberUtils';

import * as types from './Types.js';

export function searchVeiculos(filter) {
  let url = '/api/veiculos?' + filter;

  return ({ fetch }) => ({
    type: types.CONSULTA_VEICULOS,
    payload: {
      promise: fetch(url)
    }
  });
}

export function loadVeiculo(veiculo, chapa) {
  let url = `/api/veiculos/veiculo?${handlerFieldVeiculo(
    veiculo
  )}=${veiculo}&chapa=${chapa}`;

  return ({ fetch }) => ({
    type: types.LOAD_VEICULO,
    payload: {
      promise: fetch(url)
    }
  });
}

export function loadTiposAlienacao() {
  let url = '/api/veiculos/tipo-alienacao';

  return ({ fetch }) => ({
    type: types.TIPOSALIENACAO,
    payload: {
      promise: fetch(url)
    }
  });
}

export function resetConsulta() {
  return {
    type: types.RESET_CONSULTA_VEICULOS,
    payload: {}
  };
}

export function loadVeiculoDetails(veiculo) {
  return ({ fetch }) => ({
    type: types.VEICULOS_GASTOS,
    payload: {
      promise: fetch(
        `/api/veiculos/gastos?${handlerFieldVeiculo(veiculo)}=${veiculo}`
      )
    }
  });
}

export function loadGastosManutencao(veiculo, mes) {
  return ({ fetch }) => ({
    type: types.GASTOS_MANUTENCAO,
    payload: {
      promise: fetch(
        `/api/veiculos/manutencao?${handlerFieldVeiculo(
          veiculo
        )}=${veiculo}&mes=${mes}`
      )
    }
  });
}

export function loadGastosAbastecimento(veiculo, mes) {
  return ({ fetch }) => ({
    type: types.GASTOS_ABASTECIMENTO,
    payload: {
      promise: fetch(
        `/api/veiculos/abastecimento?${handlerFieldVeiculo(
          veiculo
        )}=${veiculo}&mes=${mes}`
      )
    }
  });
}

export function loadGastosPneu(veiculo, mes) {
  return ({ fetch }) => ({
    type: types.GASTOS_PNEU,
    payload: {
      promise: fetch(
        `/api/veiculos/pneu?${handlerFieldVeiculo(
          veiculo
        )}=${veiculo}&mes=${mes}`
      )
    }
  });
}

export function loadGastosBateria(veiculo, mes) {
  return ({ fetch }) => ({
    type: types.GASTOS_BATERIA,
    payload: {
      promise: fetch(
        `/api/veiculos/bateria?${handlerFieldVeiculo(
          veiculo
        )}=${veiculo}&mes=${mes}`
      )
    }
  });
}

const handlerFieldVeiculo = veiculo => {
  /*
   * Quando o portal está integrado com o oxy patrimonio
   * o tipo do ID do veiculo passa a ser UUID, atributo veiculoOxy no backend.
   */
  return isNumber(veiculo) ? 'veiculo' : 'veiculoOxy';
};
